import Swal from "sweetalert2";
import { swalAboveAppModal } from "../../../utilis/swalAboveAppModal";
import { mapWithConcurrency } from "../../../utilis/mapWithConcurrency";
import { deleteInquiryBatchItem } from "./inquiryBatchApi";

/**
 * Shared remove-student flows (same copy/behavior as Inquiry batch detail).
 */
export async function confirmRemoveInquiryBatchItem(item, batchId) {
  const confirmed = await Swal.fire(
    swalAboveAppModal({
      title: "Remove student?",
      text: `Are you sure you want to remove ${
        item?.student_name || "this student"
      } from this batch?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Remove",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
    }),
  );

  if (!confirmed.isConfirmed) return false;

  await deleteInquiryBatchItem(batchId, item.id);
  await Swal.fire(
    swalAboveAppModal({
      icon: "success",
      title: "Student removed",
      text: "The student was removed from this batch successfully.",
      timer: 1400,
      showConfirmButton: false,
    }),
  );
  return true;
}

export async function confirmRemoveInquiryBatchItems(rows = []) {
  const ids = rows.filter((row) => row?.batchId && row?.itemId);
  if (!ids.length) return false;

  const confirmed = await Swal.fire(
    swalAboveAppModal({
      title: "Remove selected students?",
      text: `Are you sure you want to remove ${ids.length} selected student${
        ids.length > 1 ? "s" : ""
      } from their batch(es)?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Remove",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc2626",
    }),
  );

  if (!confirmed.isConfirmed) return false;

  await mapWithConcurrency(ids, (row) =>
    deleteInquiryBatchItem(row.batchId, row.itemId),
  );

  await Swal.fire(
    swalAboveAppModal({
      icon: "success",
      title: "Students removed",
      text: `${ids.length} student${ids.length > 1 ? "s were" : " was"} removed successfully.`,
      timer: 1400,
      showConfirmButton: false,
    }),
  );
  return true;
}
